module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-102@2x__55c0c2235ee3c95bd4f85eec52b818c5.png";